<template>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content">
    <span class="modal__result-header">
      <span class="close-btn" @click="modalClose">
        <span>x</span>
      </span>
    </span>
    <span class="modal__result-details">
      <span class="report-title">{{ $t('REPORT') }}</span>
      <span class="report-option" v-for="(option, index) in reportOption" :key="index">
        <span @click="setReportOption(index)" :class="{'report-active': selectedOption === index}">{{ option }}</span>
      </span>

    </span>

    <div class="d-flex justify-content-center align-items-center">
      <argon-button
          color="dark"
          variant="gradient"
          class="my-4"
          style="background: #08A8FF;" v-if="! reportDone" @click="submitReport">{{ $t('REPORT') }}
      </argon-button>
      <argon-button
          color="dark"
          variant="gradient"
          class="my-4"
          style="background: #08A8FF;" v-if="reportDone">{{ $t('REPORTED') }}
      </argon-button>
    </div>
  </vue-final-modal>
</template>

<script>
import {VueFinalModal} from 'vue-final-modal';
import ArgonButton from "@/components/ArgonButton.vue";
import {sendRequest} from "@/http/axios.method";

export default {
  name: "ReportModal",
  props: ['modalShow', 'questionId'],
  components: {
    VueFinalModal,
    ArgonButton,
  },
  data() {
    return {
      showModal: this.modalShow,
      reportDone: false,
      reportOption: [this.$t('WRONG_QUESTION'), this.$t('WRONG_ANSWER'), this.$t('OTHERS')],
      selectedOption: '',
    }
  },
  methods: {
    modalClose() {
      this.emitter.emit('report-modal-close-event', {'eventContent': false});
    },
    submitReport() {
      let data = {
        question_id: this.questionId,
        type: this.reportOption[this.selectedOption],
      }
      sendRequest('post', 'v2.0/question/report', data, this.config)
          .then( response => {
            this.loaderActive = false;
            this.reportDone = response.success;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    setReportOption(index) {
      this.selectedOption = index;
    }
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;
  margin-left: 10%;
  margin-right: 10%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;

}
@media only screen and (min-width: 1200px) {
  :deep .modal-content {

    margin-left:19%;
    margin-right:19%;


  }
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}

.close-btn span{
  background: #08A8FF;
}
.modal__result-details .report-option .report-active {
  background: #08A8FF;
}

</style>
